import { useState, useContext, useEffect } from 'react'
import { ElementWidthClassContext } from 'common_packages/assets/js/contexts/ElementWidthClassContext'
import { type MagazineWidthClass, magazineWidthForSinglePageView } from 'client/constants/magazineWidthClass'
import { MagazineContext } from '../contexts/MagazineContext'

// Adjust pages view type when the width class or current pages change
export const useAdjustPagesForWidthClass = () => {
  const [currentViewType, setCurrentViewType] = useState<'single-page' | 'multi-page'>(null)

  const { elementWidthClass } = useContext(ElementWidthClassContext)
  const isSinglePageView = magazineWidthForSinglePageView.includes(elementWidthClass as MagazineWidthClass)

  const { setLastFlippedPageIndex, lastFlippedPageIndex, pages } = useContext(MagazineContext)
  const pagesAmount = pages.length

  // Determine the page view type based on the current width class
  useEffect(() => {
    if (pagesAmount > 0) {
      if (isSinglePageView && currentViewType !== 'single-page') {
        if (currentViewType != null) {
          if (lastFlippedPageIndex == null) {
            setLastFlippedPageIndex(-1)
          } else if (lastFlippedPageIndex * 2 >= pagesAmount - 1) {
            setLastFlippedPageIndex(lastFlippedPageIndex * 2 - 1)
          } else {
            setLastFlippedPageIndex(lastFlippedPageIndex * 2)
          }
        }
        setCurrentViewType('single-page')
      } else if (!isSinglePageView && currentViewType !== 'multi-page') {
        if (currentViewType != null) {
          setLastFlippedPageIndex(Math.ceil(lastFlippedPageIndex / 2))
        }
        setCurrentViewType('multi-page')
      }
    }
  }, [currentViewType, isSinglePageView, lastFlippedPageIndex, pagesAmount, setLastFlippedPageIndex])
}
